<template lang="pug">
ValidationProvider(name="Zimmer" :rules="rules" v-slot="{ errors, valid }")
  b-field(label="Zimmer" label-position="on-border"
          :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors")
    b-input(v-model="innerValue")
</template>

<script>
export default {
  props: {
    rules: {
      type: [Object, String],
      default: "required|numeric"
    },
    value: {
      type: null
    }
  },
  data() {
    return {
      innerValue: ""
    };
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    }
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>